import { Component, Input, OnInit } from '@angular/core';
import { TimeTrackingDetail } from 'src/app/model/cpl-time-tracking.model';
import { TimeTrackingTypes } from 'src/app/model/enum/cpl-time-tracking-type.enum';
import { TimeTrackingSummaryConfig } from '../../model/time-tracking-summary-config.model';
import { DEFAULT_TIME_TRACKING_SUMMARY_CONFIG } from '../../constants/default-time-tracking-summary-config.const';

@Component({
    selector: 'edl-time-tracking-summary',
    templateUrl: './time-tracking-summary.component.html',
    styleUrls: ['./time-tracking-summary.component.scss']
})
export class TimeTrackingSummaryComponent implements OnInit {
    @Input() details: TimeTrackingDetail;
    @Input() get config() {
        return this._config;
    }
    
    set config(value: TimeTrackingSummaryConfig) {
        this._config = {...DEFAULT_TIME_TRACKING_SUMMARY_CONFIG, ...value };
    }

    private _config: TimeTrackingSummaryConfig = DEFAULT_TIME_TRACKING_SUMMARY_CONFIG;
    
    isComplianceItem: boolean = false;
    title: string = '';

    ngOnInit() {
        this.title = this.getTitle();
        this.isComplianceItem = !!this.details?.ItemID;
    }

    private getTitle() {
        switch (this.details?.TimeType) {
            case TimeTrackingTypes.FLEX:
                return 'Flex Time';
            case TimeTrackingTypes.PARA:
                return 'Para Time';
            default:
                return 'Time Tracking';
        }
    }
}
